module.exports = __webpack_public_path__ + "img/banner-culture.e0dd6dd5.jpg";